var lastUnRedeemedTierIndex = -1;
var previousCartTotal;
class TieredFreeDeliveryPromos extends HTMLElement {
  constructor() {
    super();
    this.cartDrawer = document.querySelector('cart-drawer');
    this.total = parseInt(this.getAttribute('total'));
    this.tiers = this.initTiers();
    this.heightOfTiersOrigin = this.tiers.map((tier) => {
      if (tier.isRedeemed) {
        return tier.redeemedElement.getBoundingClientRect().height;
      }
      return tier.unRedeemedElement.getBoundingClientRect().height;
    });

    this.openingListener = () => {
      lastUnRedeemedTierIndex = -1;
      this.tiers.forEach((tier) => (tier.element.style.transition = 'none'));
      this.resetTransition();
      window.requestAnimationFrame(() => {
        this.tiers.forEach((tier) => (tier.element.style.transition = ''));
      });
      this.transitionTiers();
    };

    this.resetTransition();
    if (this.isCartDrawerOpen()) {
      this.transitionTiers();
    }
    previousCartTotal = this.total;
  }

  connectedCallback() {
    this.cartDrawer?.addEventListener('opening', this.openingListener);
  }

  disconnectedCallback() {
    this.cartDrawer?.removeEventListener('opening', this.openingListener);
  }

  isCartDrawerOpen() {
    return (this.cartDrawer && this.cartDrawer.open) || !this.cartDrawer;
  }

  resetTransition() {
    if (this.tiers.length === 1) {
      this.tiers[0].element.style.transform = `translateY(0%)`;
      return;
    }

    if (lastUnRedeemedTierIndex !== -1) {
      this.tiers[lastUnRedeemedTierIndex].element.style.transform = `translateY(0%)`;
      return;
    }

    if (this.isCartDrawerOpen() && previousCartTotal > this.total && this.tiers[0].isRedeemed) {
      this.tiers[1].element.style.transform = `translateY(100%)`;
      return;
    }

    if (this.tiers.length === 2) {
      this.tiers[0].element.style.transform = `translateY(0%)`;
      this.tiers[1].element.style.transform = `translateY(100%)`;
    }
  }

  transitionTiers() {
    if (this.tiers.length === 0) {
      lastUnRedeemedTierIndex = -1;
      return;
    }

    if (this.tiers.length === 1) {
      this.style.height = `${this.heightOfTiersOrigin[0]}px`;
      lastUnRedeemedTierIndex = -1;
      return;
    }

    if (lastUnRedeemedTierIndex !== -1) {
      this.style.height = `${this.heightOfTiersOrigin[lastUnRedeemedTierIndex]}px`;
      return;
    }

    if (this.isCartDrawerOpen() && previousCartTotal > this.total && this.tiers[0].isRedeemed) {
      this.style.height = `${this.heightOfTiersOrigin[1]}px`;
      this.tiers[1].element.style.transform = `translateY(0%)`;
      lastUnRedeemedTierIndex = 1;
      return;
    }

    if (this.tiers.length === 2) {
      this.style.height = `${this.heightOfTiersOrigin[1]}px`;
      this.tiers[0].element.style.transform = `translateY(0%)`;
      this.tiers[1].element.style.transform = `translateY(100%)`;
      lastUnRedeemedTierIndex = 1;
    }

    setTimeout(
      () => {
        this.tiers[0].element.style.transform = 'translateY(-100%)';
        this.tiers[1].element.style.transform = 'translateY(0%)';
      },
      parseInt(this.getAttribute('transition-delay')),
    );
  }

  initTiers() {
    return Array.from(this.querySelectorAll('slot[name^="tier"]')).map((slot, i) => {
      return {
        element: slot,
        threshold: parseInt(slot.getAttribute('threshold')),
        redeemedElement: slot.querySelector('[redeemed]'),
        unRedeemedElement: slot.querySelector('[unredeemed]'),
        isRedeemed: slot.hasAttribute('redeemed'),
      };
    });
  }
}
customElements.define('tiered-free-delivery-promos', TieredFreeDeliveryPromos);
